import { expectCode, consoleLog } from '.';
import { codeAndTestcaseLocalstorageKey as codeAndTestcaseKey, accessTokenKey } from '../constants';
import { saveTestKata } from '../services/apiService';

export const runTest = (
  testCode,
  tests,
  setTests,
  setErrors,
  setStatus,
  status,
  initTests,
  alertMsg,
  setInitTests,
  setLogs
) => {
  if (!tests.length) {
    alertMsg('Oops, no test cases have been added yet.');
    return;
  }
  let passedCount = 0,
    copied = JSON.parse(JSON.stringify(tests)),
    copiedInitTests = JSON.parse(JSON.stringify(initTests));

  const logs = [];
  for (let i = 0; i < tests.length; i++) {
    const testRun = `(()=> {
      ${consoleLog}
      ${expectCode}
      ${testCode}
      ${tests[i].code}
      return results; 
    })();`;

    try {
      const testRunResult = eval(testRun);
      copied[i].outcome = testRunResult;
      if (testRunResult.logs.length) {
        logs.push(testRunResult.logs);
      }
      if (testRunResult.every(tr => tr.result === true)) {
        passedCount++;
      }
    } catch (error) {
      console.log(error);
      setErrors([error.message]);
      return;
    }
  }

  if (logs.length) {
    setLogs(logs);
  }

  if (passedCount === tests.length) {
    // snap the code
    copied[passedCount - 1].codeSnap = testCode;
    copiedInitTests[passedCount - 1].codeSnap = testCode;

    if (initTests[status + 1]) {
      setTests([...copied, initTests[status + 1]]);
      setInitTests(copiedInitTests);
      setStatus(status + 1);
      alertMsg('All tests passed. Next one!', true);
      return;
    }

    setTests(copied);
    setInitTests(copiedInitTests);
    alertMsg('Well done! You have completed and passed all tests.', true);
    return;
  }

  if (passedCount === tests.length && initTests[status + 1]) {
    setTests([...copied, initTests[status + 1]]);
    setInitTests(copiedInitTests);
    setStatus(status + 1);
    alertMsg('All tests passed. Next one!', true);
    return;
  }

  alertMsg('Oops, test failed', false);
  setTests(copied);
};

export const saveTest = (question, title, value, tests, isPublishedLevel, isAdded = true) => {
  const code = {
    title,
    question,
    test: { code: value },
    cases: tests.map(test => ({ ...test, outcome: null, isAdded })),
  };
  return saveCodeTestcase(code, isPublishedLevel);
};

export * from './expect';

export const saveCodeTestcase = (data, isPublishedLevel) => {
  const jsonContent = JSON.stringify(data);
  window.localStorage.setItem(codeAndTestcaseKey, jsonContent);

  return saveTestKata(jsonContent, isPublishedLevel);
};

export const getCodeTestcase = () => JSON.parse(window.localStorage.getItem(codeAndTestcaseKey));

const removeHtmlTags = str => str.replace(/<\/?[^>]+(>|$)/g, ' ');

export const summariseHtml = (html, max = 10) => {
  const str = removeHtmlTags(html);
  const words = str.split(/\s+/g);

  return words.slice(0, max).join(' ') + (words.length <= max ? '' : '...');
};

export const getRandom = max => Math.floor(Math.random() * max);

export const getRandomRange = (min, max) => {
  const random = getRandom(3);
  if (random == 0) {
    return min;
  }
  if (random == 1) {
    return Math.floor((max - min) / 2);
  }

  return max;
};

export const setJwt = jwt => window.localStorage.setItem(accessTokenKey, jwt);
export const getJwt = () => window.localStorage.getItem(accessTokenKey);
export const removeJwt = () => window.localStorage.removeItem(accessTokenKey);

export const validateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
